"use strict";require("proxy-polyfill"),module.exports=require("./framer");